export enum GameType {
    ring = 'ring',
    sitNgo = 'sitNgo',
    tournament= 'tournament',
    replay = 'replay',
    spinandGo = 'spinAndGo'
}
